import { render, staticRenderFns } from "./TherapyWorkspace.vue?vue&type=template&id=ed5efd92&scoped=true"
import script from "./TherapyWorkspace.vue?vue&type=script&lang=js"
export * from "./TherapyWorkspace.vue?vue&type=script&lang=js"
import style0 from "./TherapyWorkspace.vue?vue&type=style&index=0&id=ed5efd92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5efd92",
  null
  
)

export default component.exports